module.exports = __webpack_public_path__ + "img/closeOrangeIcon.d8c4c0a4.svg";